export const formatNumber = (number: number) => number.toFixed(3);
